// AlumierMD Product Eligibility Check
document.addEventListener('DOMContentLoaded', function() {
  console.log('AlumierMD script loaded');

  // Intercept Add to Cart button clicks
  const addToCartButtons = document.querySelectorAll('form[action="/cart/add"] button[type="submit"]');
  console.log('Add to cart buttons found:', addToCartButtons.length);
  
  if (addToCartButtons.length > 0) {
    addToCartButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        console.log('Add to cart button clicked');
        e.preventDefault(); // Prevent default to run our check
        
        const form = this.closest('form[action="/cart/add"]');
        
        // Show eligibility check popup
        showEligibilityCheckPopup(form);
      });
    });
  }

  // Function to get customer email from Shopify
  function getCustomerEmail() {
    return new Promise((resolve) => {
      // Check for customer data element added via Liquid
      const customerDataEl = document.getElementById('customer-data');
      if (customerDataEl && customerDataEl.getAttribute('data-customer-email')) {
        const email = customerDataEl.getAttribute('data-customer-email');
        console.log('Email found via Liquid template:', email);
        return resolve(email);
      }
      
      // Try direct access to customer object first (fallback)
      if (window.Shopify && window.Shopify.customer && window.Shopify.customer.email) {
        console.log('Email found via window.Shopify.customer:', window.Shopify.customer.email);
        return resolve(window.Shopify.customer.email);
      }
      
      // Check if customer is logged in by looking for account elements
      const logoutLinks = document.querySelectorAll('a[href*="/account/logout"]');
      const accountLinks = document.querySelectorAll('a[href*="/account"]');
      const loginLinks = document.querySelectorAll('a[href*="/account/login"]');
      
      if (logoutLinks.length > 0 || (accountLinks.length > 0 && loginLinks.length === 0)) {
        // User appears to be logged in but we couldn't find email
        console.log('User appears logged in but email not found');
        // Show a prompt for email input
        return resolve('__prompt__');
      } else {
        // User is not logged in
        console.log('User is not logged in');
        return resolve(null);
      }
    });
  }
  
  // Function to show eligibility check popup
  function showEligibilityCheckPopup(form) {
    // Create popup if it doesn't exist
    createPopupIfNeeded();
    
    // Show popup with loading animation
    const popup = document.getElementById('alumier-eligibility-popup');
    const loadingDiv = document.getElementById('alumier-loading');
    
    if (popup && loadingDiv) {
      popup.style.display = 'block';
      loadingDiv.style.display = 'flex';
      
      // Hide other elements
      document.getElementById('alumier-check-form').style.display = 'none';
      document.getElementById('alumier-results').style.display = 'none';
      
      // Get customer email
      getCustomerEmail().then(email => {
        let customerEmail = email;
        
        console.log('Customer email result:', customerEmail);
        
        // If email is special prompt value, show email prompt
        if (customerEmail === '__prompt__') {
          // Show popup prompting for email
          showEmailPrompt(form);
          return;
        }
        
        // If no email was found (user not logged in), show registration form
        if (!customerEmail) {
          showNotFoundResult('');
          return;
        }
        
        console.log('Checking eligibility for email:', customerEmail);
        
        // Send the verification request to the webhook - keep using the original verification webhook
        fetch('https://hook.eu2.make.com/sjp5e7tc2x0iujmffgxawg6wrd6mgsdl', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: customerEmail })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Webhook response:', data);
          
          // Process the response
          if (data.sale_allowed) {
            // User is eligible, add to cart
            showEligibleResult(form);
          } else if (data.reason_code === "patient_not_owned") {
            // User belongs to another provider
            showNotOwnedResult();
          } else if (data.reason_code === "patient_not_found") {
            // User not registered - show registration form
            showNotFoundResult(customerEmail);
          } else {
            // Unknown or error response
            showErrorResult("There seems to be an problem registering your details. <br><br> Please speak to a member of our team on <br> 020 3070 3833 or 07522002050. <br> <br> Alternatively, please email us at hello@skinpharmacy.com to place your order.");
          }
        })
        .catch(error => {
          console.error('Error contacting verification service:', error);
          showErrorResult("There seems to be an problem registering your details. <br><br> Please speak to a member of our team on <br> 020 3070 3833 or 07522002050. <br> <br> Alternatively, please email us at hello@skinpharmacy.com to place your order.");
        });
      });
    }
  }
  
  // Function to show eligible result
  function showEligibleResult(form) {
    const loadingDiv = document.getElementById('alumier-loading');
    const resultsDiv = document.getElementById('alumier-results');
    
    if (loadingDiv && resultsDiv) {
      loadingDiv.style.display = 'none';
      
      resultsDiv.innerHTML = `
        <div style="text-align: center; padding: 20px; background-color: #d4edda; color: #155724; margin-bottom: 20px;">
          <p>Your account is verified. Adding product to cart...</p>
        </div>
      `;
      
      resultsDiv.style.display = 'block';
      
      // Submit the form after a short delay
      setTimeout(function() {
        closePopup();
        if (form) form.submit();
      }, 1500);
    }
  }
  
  // Function to create popup if it doesn't exist
  function createPopupIfNeeded() {
    if (document.getElementById('alumier-eligibility-popup')) {
      return; // Popup already exists
    }
    
    // Create CSS for spinner
    const spinnerCSS = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .alumier-spinner {
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-radius: 50%;
        border-top: 4px solid #3498db;
        width: 40px;
        height: 40px;
        animation: spin 1s linear infinite;
      }
      #alumier-eligibility-popup {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        z-index: 9999;
        display: none;
      }
      .alumier-popup-content {
        position: relative;
        width: 90%;
        max-width: 500px;
        margin: 100px auto;
        background: white;
        padding: 30px;
        border-radius: 5px;
      }
      .alumier-button {
        font-family: var(--font-button-family);
        font-weight: var(--font-button-weight);
        font-style: var(--font-button-style);
        text-transform: var(--font-button-text-transform);
        letter-spacing: var(--font-button-letter-spacing);
        position: relative;
        box-sizing: border-box;
        text-decoration: none;
        border: 0;
        border-radius: 4px;
        font-size: 1.4rem;
        line-height: var(--font-body-line-height);
        -webkit-appearance: none;
        appearance: none;
        cursor: pointer;
        overflow: hidden;
        z-index: 1;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        min-width: 10rem;
        min-height: 5.2rem;
        padding: 0 3.2rem;
        transition: background-color 0.3s, color 0.3s;
      }
      .alumier-button--primary {
        background-color: #6a8d5d;
        color: white;
      }
      .alumier-button--primary:hover {
        background-color: #5a7d4d;
      }
      .alumier-button--secondary {
        background-color: #f5f5f5;
        color: #333;
      }
      .alumier-button--secondary:hover {
        background-color: #e5e5e5;
      }
      @media screen and (min-width: 576px) {
        .alumier-button {
          min-height: 5.6rem;
          font-size: 1.5rem;
        }
      }
    `;
    
    // Add CSS to page
    const styleElement = document.createElement('style');
    styleElement.textContent = spinnerCSS;
    document.head.appendChild(styleElement);
    
    // Create popup HTML
    const popupHTML = `
      <div id="alumier-eligibility-popup">
        <div class="alumier-popup-content">
          <h2 style="text-align: center;">AlumierMD Eligibility</h2>
          
          <!-- Form for registration -->
          <form id="alumier-check-form" style="display:none;">
            <p>Please complete your information to order AlumierMD products through Skin Pharmacy</p>
            <div style="margin-bottom:15px;">
              <label for="alumier-firstname">First Name</label>
              <input type="text" id="alumier-firstname" required style="width:100%; padding:8px; border:1px solid #ddd;">
            </div>
            <div style="margin-bottom:15px;">
              <label for="alumier-lastname">Last Name</label>
              <input type="text" id="alumier-lastname" required style="width:100%; padding:8px; border:1px solid #ddd;">
            </div>
            <div style="margin-bottom:15px;">
              <label for="alumier-email">Email</label>
              <input type="email" id="alumier-email" required style="width:100%; padding:8px; border:1px solid #ddd;">
            </div>
            
            <div style="display:flex; justify-content:space-between;">
              <button type="button" id="alumier-cancel" class="alumier-button alumier-button--secondary">Cancel</button>
              <button type="submit" id="alumier-submit" class="alumier-button alumier-button--primary">Register with Skin Pharmacy</button>
            </div>
          </form>
          
          <!-- Loading animation -->
          <div id="alumier-loading" style="display:none; margin:15px 0; justify-content:center; align-items:center; flex-direction:column; padding:20px;">
            <div class="alumier-spinner"></div>
            <p style="margin-top:15px; text-align:center;">Verifying eligibility to purchase AlumierMD products...</p>
          </div>
          
          <!-- Results container -->
          <div id="alumier-results" style="display:none;"></div>
        </div>
      </div>
    `;
    
    // Add popup to page
    document.body.insertAdjacentHTML('beforeend', popupHTML);
    
    // Add close button handler
    const cancelButton = document.getElementById('alumier-cancel');
    if (cancelButton) {
      cancelButton.addEventListener('click', closePopup);
    }
  }
  
  // Function to show not owned result
  function showNotOwnedResult() {
    const loadingDiv = document.getElementById('alumier-loading');
    const resultsDiv = document.getElementById('alumier-results');
    
    if (loadingDiv && resultsDiv) {
      loadingDiv.style.display = 'none';
      
      resultsDiv.innerHTML = `
        <div style="text-align: center; padding: 20px; background-color: #f8d7da; color: #721c24; margin-bottom: 20px;">
          <p>This email address is already connected to a different provider. <br><br> Please speak to a member of our team on <br> 020 3070 3833 or 07522002050. <br><br> Alternatively, please email us at hello@skinpharmacy.com to place your order.</p>
        </div>
        <div style="text-align: center;">
          <button id="alumier-close" class="alumier-button alumier-button--primary">Close</button>
        </div>
      `;
      
      resultsDiv.style.display = 'block';
      
      // Add close button handler
      document.getElementById('alumier-close').addEventListener('click', closePopup);
    }
  }
  
  // Function to show not found result (registration needed)
  function showNotFoundResult(email) {
    const loadingDiv = document.getElementById('alumier-loading');
    const checkForm = document.getElementById('alumier-check-form');
    
    if (loadingDiv && checkForm) {
      loadingDiv.style.display = 'none';
      
      // Update form title
      const formTitle = document.querySelector('#alumier-eligibility-popup h2');
      if (formTitle) {
        formTitle.textContent = 'Register with AlumierMD';
      }
      
      // Update form description
      const formDescription = document.querySelector('#alumier-check-form p');
      if (formDescription) {
        formDescription.textContent = 'Please complete your information to order AlumierMD products through Skin Pharmacy.';
      }
      
      // Pre-fill email
      const emailInput = document.getElementById('alumier-email');
      if (emailInput) {
        emailInput.value = email || '';
        if (email) {
          emailInput.readOnly = true;
          emailInput.style.backgroundColor = '#f8f9fa';
        } else {
          emailInput.readOnly = false;
          emailInput.style.backgroundColor = '';
        }
      }
      
      // Update submit button
      const submitButton = document.getElementById('alumier-submit');
      if (submitButton) {
        submitButton.textContent = 'Register with Skin Pharmacy';
      }
      
      // Remove old event listener and add new one
      const newForm = checkForm.cloneNode(true);
      checkForm.parentNode.replaceChild(newForm, checkForm);
      
      // Use the new registration webhook
      newForm.addEventListener('submit', function(e) {
        e.preventDefault();
        const firstName = document.getElementById('alumier-firstname').value;
        const lastName = document.getElementById('alumier-lastname').value;
        const emailValue = document.getElementById('alumier-email').value;
        
        // Change button text when submitting
        const submitButton = document.getElementById('alumier-submit');
        if (submitButton) {
          submitButton.textContent = 'Registering Skin Pharmacy as your chosen provider for Alumier products';
          submitButton.disabled = true;
        }
        
        // Show loading
        newForm.style.display = 'none';
        document.getElementById('alumier-loading').style.display = 'flex';
        
        // Send registration data to your webhook
        fetch('https://hook.eu2.make.com/8objwv41wkxlpgkvjg6m9arulfk7uvdv', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            first_name: firstName,
            last_name: lastName,
            email: emailValue
          })
        })
        .then(response => response.json())
        .then(data => {
          document.getElementById('alumier-loading').style.display = 'none';
          const resultsDiv = document.getElementById('alumier-results');
          
          if (data.registered) {
            // Registration successful
            resultsDiv.innerHTML = `
              <div style="text-align: center; padding: 20px; background-color: #d4edda; color: #155724; border-radius: 4px; margin-bottom: 20px;">
                <h3 style="margin-top: 0;">Registration Successful!</h3>
                <p>${data.message || 'You have been successfully registered with AlumierMD.'}</p>
                <p>You can now add this product to your cart.</p>
              </div>
              <div style="text-align: center;">
                <button id="try-add-cart" class="alumier-button alumier-button--primary">Add to Cart</button>
              </div>
            `;
            
            // Add handler for add to cart button
            document.getElementById('try-add-cart').addEventListener('click', function() {
              closePopup();
              if (form) form.submit(); // Submit the original add to cart form
            });
          } else {
            // Registration failed
            resultsDiv.innerHTML = `
              <div style="text-align: center; padding: 20px; background-color: #f8d7da; color: #721c24; border-radius: 4px; margin-bottom: 20px;">
                <h3 style="margin-top: 0;">Registration Failed</h3>
                <p>${data.message || 'There was a problem with your registration.'}</p>
                <p>Please try again or contact customer service.</p>
              </div>
              <div style="text-align: center;">
                <button id="alumier-close" class="alumier-button alumier-button--primary">Close</button>
              </div>
            `;
            
            // Add close button handler
            document.getElementById('alumier-close').addEventListener('click', closePopup);
          }
          
          resultsDiv.style.display = 'block';
        })
        .catch(error => {
          console.error('Error during registration:', error);
          showErrorResult("There seems to be an problem registering your details. <br><br> Please speak to a member of our team on <br> 020 3070 3833 or 07522002050. <br> <br> Alternatively, please email us at hello@skinpharmacy.com to place your order.");
        });
      });
      
      // Add cancel button handler
      const cancelButton = document.getElementById('alumier-cancel');
      if (cancelButton) {
        cancelButton.addEventListener('click', closePopup);
      }
      
      // Show form
      newForm.style.display = 'block';
    }
  }
  
  // Function to show email prompt
  function showEmailPrompt(form) {
    const loadingDiv = document.getElementById('alumier-loading');
    const resultsDiv = document.getElementById('alumier-results');
    
    if (loadingDiv && resultsDiv) {
      loadingDiv.style.display = 'none';
      
      resultsDiv.innerHTML = `
        <div style="text-align: center; padding: 20px; background-color: #f5f5f5; color: #0c5460; margin-bottom: 20px;">
          <p>Please enter your email address to verify eligibility to purchase AlumierMD products.</p>
          <div style="margin:15px 0;">
            <input type="email" id="customer-email-input" placeholder="Your email address" style="width:100%; padding:8px; border:1px solid #ddd; margin-bottom:10px;">
            <div style="display:flex; justify-content:space-between;">
              <button id="cancel-email-verify" class="alumier-button alumier-button--secondary">Cancel</button>
              <button id="submit-email-verify" class="alumier-button alumier-button--primary">Verify</button>
            </div>
          </div>
        </div>
      `;
      
      resultsDiv.style.display = 'block';
      
      // Add handlers
      document.getElementById('cancel-email-verify').addEventListener('click', closePopup);
      document.getElementById('submit-email-verify').addEventListener('click', function() {
        const emailInput = document.getElementById('customer-email-input');
        if (emailInput && emailInput.value && emailInput.value.includes('@')) {
          // Show loading again
          resultsDiv.style.display = 'none';
          loadingDiv.style.display = 'flex';
          
          // Send the verification request with the provided email
          fetch('https://hook.eu2.make.com/sjp5e7tc2x0iujmffgxawg6wrd6mgsdl', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: emailInput.value })
          })
          .then(response => response.json())
          .then(data => {
            console.log('Webhook response:', data);
            
            // Process the response
            if (data.sale_allowed) {
              // User is eligible, add to cart
              showEligibleResult(form);
            } else if (data.reason_code === "patient_not_owned") {
              // User belongs to another provider
              showNotOwnedResult();
            } else if (data.reason_code === "patient_not_found") {
              // User not registered - show registration form
              showNotFoundResult(emailInput.value);
            } else {
              // Unknown or error response
              showErrorResult("There seems to be an problem registering your details. <br><br> Please speak to a member of our team on <br> 020 3070 3833 or 07522002050. <br> <br> Alternatively, please email us at hello@skinpharmacy.com to place your order.");
            }
          })
          .catch(error => {
            console.error('Error contacting verification service:', error);
            showErrorResult("There seems to be an problem registering your details. <br><br> Please speak to a member of our team on <br> 020 3070 3833 or 07522002050. <br> <br> Alternatively, please email us at hello@skinpharmacy.com to place your order.");
          });
        } else {
          // Show validation error
          alert('Please enter a valid email address');
        }
      });
    }
  }

  // Function to show error result
  function showErrorResult(message) {
    const loadingDiv = document.getElementById('alumier-loading');
    const resultsDiv = document.getElementById('alumier-results');
    
    if (loadingDiv && resultsDiv) {
      loadingDiv.style.display = 'none';
      
      resultsDiv.innerHTML = `
        <div style="text-align: center; padding: 20px; background-color: #f8d7da; color: #721c24; margin-bottom: 20px;">
          <p>${message}</p>
        </div>
        <div style="text-align: center;">
          <button id="alumier-close" style="display: inline-flex; justify-content: center; align-items: center; min-width: 10rem; min-height: 5.5rem; background-color: rgb(var(--color-button)); color: rgb(var(--color-button-text)); border: 0; border-radius: 0; border-box: none; font-size: 1.4rem; line-height: 1.4; transition: background-color var(--duration-default), color var(--duration-default); padding: 0 3rem; text-transform: none; font-family: var(--font-button-family); font-weight: var(--font-button-weight); font-style: var(--font-button-style); text-decoration: none; position: relative; letter-spacing: var(--font-button-letter-spacing);">Close</button>
        </div>
      `;
      
      resultsDiv.style.display = 'block';
      
      // Add close button handler
      document.getElementById('alumier-close').addEventListener('click', closePopup);
    }
  }
  
  // Function to close popup
  function closePopup() {
    const popup = document.getElementById('alumier-eligibility-popup');
    if (popup) {
      popup.style.display = 'none';
      
      // Reset popup state
      const checkForm = document.getElementById('alumier-check-form');
      if (checkForm) {
        checkForm.reset();
        checkForm.style.display = 'none';
      }
      
      document.getElementById('alumier-loading').style.display = 'none';
      document.getElementById('alumier-results').style.display = 'none';
      
      // Reset title
      const formTitle = document.querySelector('#alumier-eligibility-popup h2');
      if (formTitle) {
        formTitle.textContent = 'AlumierMD Eligibility';
      }
    }
  }
});